const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/$slug/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/$lang/$family/$slug")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});